import { PaymentEffects } from './payment.effect';

export const effects: any[] = [PaymentEffects];
